import React, { useEffect,useState } from 'react';
import {
	Container,
	Grid,
	Typography,
	TextField,
	CircularProgress,
	Button,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import queryString from 'query-string';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import useStyles from '../../styles/style';
import { resetPasswordAction } from '../../redux/actions/userAction';
import SnackAlert from '../helpers/SnackAlert';

const ResetPassword = () => {
	const { t } = useTranslation();
	const classes = useStyles();
	const dispatch = useDispatch();

	const resetSchema = Yup.object({
		password: Yup.string()
			.min(6, `${t('password-error')}`)
			.required(),
		confirmationPassword: Yup.string().oneOf(
			[Yup.ref('password')],
			`${t('confirm-password-error')}`
		),
	});

	const reset = useSelector(state => state.reset);
	const [open, setOpen] = useState(false);

	const { token } = queryString.parse(location.search);

	const handleSubmit = values => {
		dispatch(resetPasswordAction({ ...values, resetToken: token }));
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(!open);
	};

	useEffect(() => {
		document.title = `${t('title')} | ${t('reset-text')}`;
	}, [t]);

	if (!token) {
		return <Redirect to='/' />;
	}
	return (
		<div>
			<Container>
				<Grid
					container
					justifyContent='center'
					alignItems='center'
					style={{ height: '30vh' }}
				>
					<Grid item xs={12} sm={12} md={6}>
						<SnackAlert
							message={reset.message}
							open={open}
							handleClose={handleClose}
							severity='success'
						/>
						<Typography variant='h6'>{t('reset-text')}</Typography>
						<Formik
							validationSchema={resetSchema}
							initialValues={{ password: '', confirmationPassword: '' }}
							onSubmit={(values, { resetForm }) => {
								resetForm();
								handleSubmit(values);
							}}
						>
							{props => (
								<Form>
									<TextField
										size='small'
										margin='normal'
										variant='outlined'
										type='password'
										id='password'
										name='password'
										fullWidth
										label={t('new-password')}
										value={props.values.password}
										onChange={props.handleChange('password')}
										error={
											props.values.password !== '' &&
											Object.prototype.hasOwnProperty.call(
												props.errors,
												'password'
											)
										}
										helperText={
											props.values.password !== '' && props.errors.password
										}
									/>
									<TextField
										size='small'
										margin='normal'
										variant='outlined'
										type='password'
										id='confirmationPassword'
										name='confirmationPassword'
										fullWidth
										label={t('confirm-password')}
										value={props.values.confirmationPassword}
										onChange={props.handleChange('confirmationPassword')}
										error={
											props.values.confirmationPassword !== '' &&
											Object.prototype.hasOwnProperty.call(
												props.errors,
												'confirmationPassword'
											)
										}
										helperText={
											props.values.confirmationPassword !== '' &&
											props.errors.confirmationPassword
										}
									/>
									<Button
										type='submit'
										variant='contained'
										className={classes.submit}
										disabled={
											!props.values.password ||
											!props.values.confirmationPassword ||
											reset.loading ||
											Object.keys(props.errors).length !== 0
										}
									>
										{reset.loading ? (
											<>
												<CircularProgress size={20} />
												&nbsp;
												{t('loading')}
											</>
										) : (
											t('send')
										)}
									</Button>
								</Form>
							)}
						</Formik>
					</Grid>
				</Grid>
			</Container>
		</div>
	);
};

export default ResetPassword;
